import PropTypes from "prop-types";
import { IconButton } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

const Avatar = ({ onClick }) => {
  return (
    <IconButton alt="Account management menu" onClick={onClick}>
      <AccountCircleOutlinedIcon />
    </IconButton>
  );
};

Avatar.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Avatar;
